<template>
  <div class="index-box">
    <div class="page-title">当前位置：北京老科技工作者总会会员管理系统 > 账号管理 </div>
    <div class="info-box">
      <div class="info-title">
        <span>账号管理 </span>
      </div>
      <div class="account-tab">
        <a href="javascript:void 0" :class="{active:tab === 0}" @click="tab=0">账号设置</a>
        <a href="javascript:void 0" :class="{active:tab === 1}" @click="tab=1">密码修改</a>
      </div>
      <div class="account-box" v-if="tab === 0">
        <div class="account-item">
          <span><i class="iconfont iconbangdingshouji"></i>手机号</span>
          <div>{{phone}}</div>
          <el-button class="set-btn" @click="setPhone = !setPhone">{{!setPhone?'修改':'取消修改'}}</el-button>
        </div>
        <div class="pass-set" v-if="setPhone">
          <div>
            <el-input  v-model="nphone" placeholder="请输入新手机号"></el-input>
          </div>
          <div>
            <el-input v-model="code2" placeholder="请输入验证码" maxlength="6"></el-input>
            <el-button class="get-code" @click="getSms2">{{codeText2}}</el-button>
          </div>
          <el-button class="submit-btn" @click="setTel">确定</el-button>
        </div>
<!--        <div class="account-item" v-if="!wxState">-->
<!--          <span><i class="iconfont iconwx active"></i>微信号</span>-->
<!--          <div class="active">还未绑定微信</div>-->
<!--          <a href="https://open.weixin.qq.com/connect/qrconnect?appid=wxc2c56ea572d063da&redirect_uri=http://bjlkz.emof.cn/home/account&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect" class="set-btn">立即绑定</a>-->
<!--        </div>-->
<!--        <div class="account-item" v-if="wxState">-->
<!--          <span><i class="iconfont iconwx active"></i>微信</span>-->
<!--          <div class="active">{{wechatNickname}}</div>-->
<!--          <el-button class="set-btn" @click="unbindWx">解除绑定</el-button>-->
<!--        </div>-->
      </div>
      <div class="account-box" v-if="tab === 1">
        <h2 class="user-phone">手机号：{{phone}}</h2>
        <div class="pass-set">
          <div>
            <el-input v-model="code" placeholder="请输入验证码" maxlength="6"></el-input>
            <el-button class="get-code" @click="getSms">{{codeText}}</el-button>
          </div>
          <div>
            <el-input type="password" v-model="pass" placeholder="请输入新密码"></el-input>
          </div>
          <div>
            <el-input type="password" v-model="npass" placeholder="请再次输入新密码"></el-input>
          </div>
          <el-button class="submit-btn" @click="setPass">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from "../../store";

  export default {
    name: "Account",
    data() {
      return {
        tab:0,
        setPhone:false,
        phone:'',
        nphone:'',
        code:'',
        code2:'',
        pass:'',
        npass:'',
        codeText: '发送验证码', // 验证码文字
        codeText2: '发送验证码', // 验证码文字
        id: null, // 计时器id
        id2: null, // 计时器id
        timeId: null, // 一次性计时器id
        timeId2: null, // 一次性计时器id
        wxState:'',
        wechatNickname:''
      }
    },
    created() {
      this.phone = this.$store.state.user.phone
      this.$emit('setNav', 4 )
      this.getWxState()
    },
    methods:{
      /*
      * 获取微信状态
      * */
      getWxState(){
        this.$api.apiContent.getUser({
          token: this.$store.state.user.token,
        }).then((res) => {
          this.wxState = res.row.bindWechat
          this.wechatNickname = res.row.wechatNickname
          if(!this.wxState && this.$route.query.code){
            this.bindWx()
          }
        }).catch(e => {
          this.$toast(e.msg)
        })
      },
      /*
      * 绑定微信
      * */
      bindWx(){
        this.$api.apiContent.bindWx({
          token: this.$store.state.user.token,
          code:this.$route.query.code,
          os:'pc'
        }).then(() => {
          this.getWxState()
        }).catch(() => {
        })
      },

      /*
      * 解除绑定
      * */
      unbindWx(){
        let that = this
        that.$confirm('您确定要解绑微信吗?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$api.apiContent.unBindeWx({
            token: that.$store.state.user.token,
          }).then(() => {
            that.getWxState()
          }).catch(e => {
            that.$toast(e.msg)
          })
        }).catch(() => {

        });

      },

      /*
      * 修改手机号
      * */
      setTel(){
        if (this.$tools.checkTel(this.nphone)) {
          this.$toast('请输入正确的手机号')
          return
        }
        if (this.$tools.checkRequired(this.code2)) {
          this.$toast('请输入验证码')
          return
        }
        this.$api.apiContent.setPhone({
          token: this.$store.state.user.token,
          oldPhone:this.phone,
          newPhone:this.nphone,
          verifyCode:this.code2
        }).then(() => {
          this.$toast('修改成功,请重新登录')
          setTimeout(()=>{
            sessionStorage.clear()
            localStorage.clear()
            store.user = null
            window.location.href = '/login'
          },1000)
        }).catch(e => {
          this.$toast(e.msg)
        })
      },
      /*
      * 修改密码
      * */
      setPass(){
        if(!this.pass){
          this.$toast('请输入新密码')
          return
        }
        if(this.pass !== this.npass){
          this.$toast('两次密码不相同')
          return
        }
        this.$api.apiContent.setpass({
          phone: this.phone,
          pass:this.$md5(this.pass),
          verifyCode:this.code
        }).then(()=>{
          this.$toast('修改成功,请重新登录')
          setTimeout(()=>{
            sessionStorage.clear()
            localStorage.clear()
            store.user = null
            window.location.href = '/login'
          },1000)
        }).catch(e => {
          this.$toast(e.msg)
        })
      },
      /*
      * 获取验证码
      * */
      getSms(){

        if (this.codeText === '发送验证码' || this.codeText === '重新发送') {
          let num = 60
          this.id = setInterval(() => {
            if (num === 0) {
              clearInterval(this.id)
              this.codeText = '重新发送'
              return
            }
            num--
            this.codeText = "重新发送(" + num + "s)"
          }, 1000)
          this.$api.apiContent.send({
            phone: this.phone,
          }).then().catch(e => {
            this.$toast(e.info)
            this.codeText = '重新发送'
            clearInterval(this.id)
          })
        }
      },
      getSms2(){
        if (this.$tools.checkTel(this.nphone)) {
          this.$toast('请输入正确的手机号')
          return
        }
        if (this.codeText2 === '发送验证码' || this.codeText2 === '重新发送') {
          let num = 60
          this.id2 = setInterval(() => {
            if (num === 0) {
              clearInterval(this.id2)
              this.codeText2 = '重新发送'
              return
            }
            num--
            this.codeText2 = "重新发送(" + num + "s)"
          }, 1000)
          this.$api.apiContent.send({
            phone: this.nphone,
          }).then().catch(e => {
            this.$toast(e.info)
            this.codeText2 = '重新发送'
            clearInterval(this.id2)
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .index-box {
    .page-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 62px;
      padding: 0 24px;
      line-height: 62px;
      background-color: #ffffff;
      margin-bottom: 10px;
      a{
        display: block;
        width: 102px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        color: #2b8ee3;
        background-color: #e9f5ff;
        border-radius: 13px;
      }
    }

    .info-box {
      min-height: 712px;
      padding: 25px 27px;
      background: #fff;
      .info-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding: 0 12px;
        background-image: linear-gradient(0deg,
          #2084da 0%,
          #3295e8 100%);
        border-radius: 4px;

        span {
          font-size: 20px;
          font-weight: bold;
          color: #ffffff;
        }

        a.more {
          width: 56px;
          height: 26px;
          text-align: center;
          line-height: 26px;
          font-size: 14px;
          color: #0c7cbc;
          background-color: #e9f5ff;
          border-radius: 13px;
        }
      }
      .account-tab{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 340px;
        margin: 30px auto;
        a{
          display: block;
          width: 160px;
          height: 50px;
          text-align: center;
          line-height: 48px;
          font-size: 18px;
          color: #333;
          background-color: #e9f5ff;
          border-radius: 8px;
          border: solid 1px #d9eeff;
          &.active{
            background: #2b8ee3;
            color: #fff;
          }
        }
      }
      .account-box{
        padding-top: 30px;
        .account-item{
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 646px;
          height: 114px;
          padding: 0 35px;
          margin: 0 auto 15px;
          background-color: #e9f5ff;
          border-radius: 4px;
          border: solid 1px #d9eeff;
          span{
            display: flex;
            align-items: center;
            font-size: 20px;
            color: #2b8ee3;
            i{
              font-size: 30px;
              margin-top: -3px;
              margin-right: 5px;
              &.active{
                color: #36c12d;
              }
            }
          }
          div{
            flex: 1;
            margin: 0 30px;
            color: #2b8ee3;
            font-size: 20px;
            &.active{
              color: #999;
            }
          }
          .set-btn{
            display: block;
            width: 100px;
            height: 36px;
            padding: 0;
            border: 0;
            text-align: center;
            line-height: 36px;
            color: #fff;
            background-image: linear-gradient(0deg,
              #2185da 0%,
              #3295e8 100%);
            border-radius: 4px;
          }
        }
        .user-phone{
          text-align: center;
          font-size: 24px;
          color: #2b8ee3;
        }
        .pass-set{
          width: 448px;
          margin: 40px auto;
          div{
            margin-bottom: 10px ;
            position: relative;
            .get-code{
              position: absolute;
              top: 0;
              right: 0;
              border: 0;
              background: transparent;
              color: #0c7cbc;
              font-weight: normal;
            }
          }
        }
        .submit-btn{
          display: block;
          width: 162px;
          height: 48px;
          padding: 0;
          border:0;
          margin: 30px auto;
          text-align: center;
          line-height: 48px;
          color: #fff;
          background-image: linear-gradient(90deg,
            #0d80c1 0%,
            #1aa8e3 100%);
          border-radius: 8px;
        }
      }
    }
  }
</style>
